import http from '../auth/httpService';

const apiEndpoint = '/projects';
const apiEndpointYear = '/year';

function projectUrl(slug) {
  return `${apiEndpoint}/${slug}`;
}

function yearProjectUrl(year) {
  return `${apiEndpoint}${apiEndpointYear}/${year}`;
}

export function getProjects() {
  return http.get(apiEndpoint);
}

export function getProject(projectSlug) {
  return http.get(projectUrl(projectSlug));
}

export function getProjectsByYear(year) {
  return http.get(yearProjectUrl(year));
}

export function saveProject(project) {
  if (project.slug) {
    const body = { ...project };
    //delete body.slug;
    return http.put(projectUrl(project.slug), body);
  }
  return http.post(apiEndpoint, project);
}

export function updateProject_isOpenField(slug) {
  return http.patch(`${apiEndpoint}/${slug}`);
}

export function deleteProject(projectSlug) {
  return http.delete(projectUrl(projectSlug));
}
